import { render, staticRenderFns } from "./DeficienciesItem.vue?vue&type=template&id=07a1eca2"
import script from "./DeficienciesItem.vue?vue&type=script&lang=js"
export * from "./DeficienciesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports